import { AdminManageStudyManager } from './manage-study-manager';

export default AdminManageStudyManager;
